import TargetsProductResult from './ResultPage';

export default TargetsProductResult;
